import { z } from 'zod';
import type { Message } from './messages.js';
import type { Task } from './tasks.js';

export const searchQuerySchema = z.object({
  q: z.string().trim().min(2).max(100),
});
export type SearchQuery = z.infer<typeof searchQuerySchema>;

export interface SearchResults {
  messages: Message[];
  tasks: Task[];
}
